export enum VolumeBreakpoint {
  Muted = 'muted',
  Min = 'min',
  Max = 'max',
}
